import { createFileRoute, Link } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthLayout } from '@/features/auth/AuthLayout';
import { ResetPasswordForm } from '@/features/auth/ResetPasswordForm';
import { useT } from '@/i18n/useT';

const ResetPasswordSearch = z.object({ token: z.string().optional() });

export const Route = createFileRoute('/reset-password')({
  validateSearch: ResetPasswordSearch,
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const t = useT();
  const { token } = Route.useSearch();
  return (
    <AuthLayout
      title={t('auth.reset.title')}
      description={token ? t('auth.reset.newSubtitle') : t('auth.reset.requestSubtitle')}
      footer={
        <Link to="/login" className="text-primary underline-offset-4 hover:underline">
          {t('auth.reset.backToLogin')}
        </Link>
      }
    >
      <ResetPasswordForm token={token} />
    </AuthLayout>
  );
}
